export default "__VITE_ASSET__DW00LtBr__"